import { valueAccessor } from '@syncfusion/ej2-react-grids'
import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import CostBearingDepartmentDiv from './CostBearingDepartmentDiv'
import { exportFile } from 'tyan/public/index'

class AdvanceOrder extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.handlerInitValue(this.props.id)
    }

    componentWillUnmount = () => {
        this.unmount = true
    }

    handlerInitValue = (id) => {
        const { taskName } = this.props
        Tyan.doPostEvent({
            event: 'GetAdvanceOrder',
            data: { id, taskName },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas, })
                }
            }
        })
    }

    handlerAdvanceExport = () => {
        const { id } = this.state
        exportFile(null, null, "AdvanceExport?id=" + id)
    }

    handlerSave = (costBearingDepID = 0, name = '') => {
        const { readOnly } = this.props
        const { id, changedValues基本信息 } = this.state
        // if (readOnly) {
        //     if (name !== '') {
        //         Tyan.pubForm.showDialog('成本承担部门', props => <CostBearingDepartmentDiv {...props} id={costBearingDepID} advanceExpenseID={id} readOnly={readOnly} />)
        //     }
        // }
        //else {
        const 预支名称 = getFormValue(this, '基本信息', '预支名称')
        const 状态 = getFormValue(this, '基本信息', '状态')
        var item = ['预支人', /* '所属单位', */ '委外单位', '预支金额', '付款方式', '付款期限']
        for (var i = 0; i < item.length; i++) {
            if (item[i] == '委外单位')
                if (预支名称 == '其它') continue
            if (!getFormValue(this, '基本信息', item[i])) {
                Ext.toast(`${item[i]}必填`)
                return
            }
        }
        if (this.bChanged() && 状态 == '申请中')
            Tyan.doPostEvent({
                event: 'SaveAdvanceOrder',
                data: { id, changedValues基本信息 },
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('保存成功')
                        this.handlerInitValue(id)
                        // if (name !== '') {
                        //     Tyan.pubForm.showDialog('成本承担部门', props => <CostBearingDepartmentDiv {...props} id={costBearingDepID} advanceExpenseID={id}
                        //         readOnly={状态 !== '申请中'} onSave={() => this.handlerInitValue(id)} />)
                        // }
                    }
                }
            })
        // else {
        //     if (name !== '') {
        //         Tyan.pubForm.showDialog('成本承担部门', props => <CostBearingDepartmentDiv {...props} id={costBearingDepID} advanceExpenseID={id}
        //             readOnly={状态 !== '申请中'} onSave={() => this.handlerInitValue(id)} />)
        //     }
        // }
        //}
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteAdvanceOrder',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        const 预支名称 = getFormValue(this, '基本信息', '预支名称')
        return getFormValue(this, '基本信息', '预支人') &&
            // getFormValue(this, '基本信息', '所属单位') &&
            getFormValue(this, '基本信息', '预支金额') &&
            getFormValue(this, '基本信息', '付款方式') &&
            getFormValue(this, '基本信息', '付款期限') &&
            getFormValue(this, '基本信息', '用途说明') //&&
        //getFormValue(this, '基本信息', '附件') &&
        //getFormValue(this, '基本信息', '附件').length > 0
    }

    handleRelatedPersonChange = (v) => {
        const { optionsParas } = this.state
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        changeItemsValue(this, '基本信息', ['预支部门'], [optionsParas[v].depName])
        if (预支类型 == '员工') {
            changeItemsValue(this, '基本信息', ['开户银行'], [optionsParas[v].bank])
            changeItemsValue(this, '基本信息', ['银行账号'], [optionsParas[v].bankAccount])
            changeItemsValue(this, '基本信息', ['供应商'], [v])
        }
    }
    handleCustomerNameChange = (v) => {
        //console.log(v)
        Tyan.doPostEvent({
            event: 'GetBankMessage',
            data: { 单位名称: v },
            onEnd: ({ errorMessage, AccountOpeningBank, BankAccount }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['开户银行'], [AccountOpeningBank])
                    changeItemsValue(this, '基本信息', ['银行账号'], [BankAccount])
                }
            }
        })

    }

    handleAdvanceTypeChange = (v, id) => {
        const { optionsParas } = this.state
        Tyan.doPostEvent({
            event: 'GetCustomersData',
            data: { 预支类型: v, id: id },
            onEnd: ({ options }) => {
                if (options) {
                    this.setState({ optionsParas: { ...optionsParas, '供应商': options } })
                    //console.log(options)
                    //console.log(this.state.optionsParas)
                }
            }
        })
    }

    handleAdvanceAmountChange = (v) => {
        changeItemsValue(this, '基本信息', ['支付金额'], [v])
        this.AutoCalculation()
    }

    handleCurrencyNameChange = (v) => {
        const 申请时间 = getFormValue(this, '基本信息', '申请时间')
        Tyan.doPostEvent({
            event: 'GetExchangeRateByCurrency',
            data: { 币别: v, 申请时间 },
            onEnd: ({ errorMessage, ExchangeRate }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
                    //this.AutoCalculation()
                }
            }
        })
    }


    handleNumberChange = (v) => {
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        Tyan.doPostEvent({
            event: 'GetSupplierName',
            data: { 采购单号: v, 预支类型 },
            onEnd: ({ errorMessage, SupplierName, AccountOpeningBank, BankAccount }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['供应商', '开户银行', '银行账号'], [SupplierName, AccountOpeningBank, BankAccount])
                }
            }
        })
    }

    handleCustomerChange = (v) => {
        var person = ''
        var supplier = ''
        var customer = ''
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        if (预支类型 == '员工')
            person = v
        else if (预支类型 == '供应商')
            supplier = v
        else if (预支类型 == '客户')
            customer = v
        if (预支类型 == '其他')
            Tyan.doPostEvent({
                event: 'GetOtherBankInfo',
                data: { customer: v },
                onEnd: ({ errorMessage, bankInfo }) => {
                    if (errorMessage)
                        Tyan.pubForm.showError(errorMessage)
                    else
                        changeItemsValue(this, '基本信息', ['开户银行', '银行账号'], [bankInfo.开户银行, bankInfo.银行账号])
                }
            })
        else
            Tyan.doPostEvent({
                event: 'GetBankInfo',
                data: { person, supplier, customer },
                onEnd: ({ errorMessage, bankInfo }) => {
                    if (errorMessage)
                        Tyan.pubForm.showError(errorMessage)
                    else
                        changeItemsValue(this, '基本信息', ['开户银行', '银行账号'], [bankInfo.开户银行, bankInfo.银行账号])
                }
            })
    }
    // AutoCalculation = () => {
    //     const 税率 = getFormValue(this, '基本信息', '税率')
    //     const 预支金额 = getFormValue(this, '基本信息', '预支金额')
    //     const 汇率 = getFormValue(this, '基本信息', '汇率')
    //     var 原币金额含税 = 0
    //     var 本币金额未税 = 0
    //     var 原币金额未税 = 预支金额 ? 预支金额 : 0
    //     var 本币金额含税 = 0
    //     var d税率 = 0
    //     if (税率) {
    //         if (税率 == 'CN01：增值税13%')
    //             d税率 = 0.13
    //         else if (税率 == 'CN02：增值税9%')
    //             d税率 = 0.09
    //         else if (税率 == 'CN03：增值税6%')
    //             d税率 = 0.06
    //         else if (税率 == 'CN04：增值税3%')
    //             d税率 = 0.03
    //         else if (税率 == 'CN05：增值税1%')
    //             d税率 = 0.01
    //     }
    //     if (汇率 && 预支金额) {
    //         本币金额未税 = 预支金额 * 汇率
    //         原币金额含税 = 预支金额 * (1 + d税率)
    //         本币金额含税 = 预支金额 * 汇率 * (1 + d税率)
    //     }
    //     changeItemsValue(this, '基本信息', ['原币金额未税', '本币金额未税', '原币金额含税', '本币金额含税'], [原币金额未税, 本币金额未税, 原币金额含税, 本币金额含税])
    // }

    fieldset基本信息 = () => {
        const { readOnly } = this.props
        const 预支名称 = getFormValue(this, '基本信息', '预支名称')
        const 采购单号 = getFormValue(this, '基本信息', '采购单号')
        const 状态 = getFormValue(this, '基本信息', '状态')
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        const 客户名称 = getFormValue(this, '基本信息', '客户名称')
        const { list } = getListItems(this, '基本信息', '成本承担部门')
        //console.log(this.state)
        //console.log(预支类型)
        //console.log('optionsParas', this.state.optionsParas)
        //console.log('init', this.state.initValues基本信息)
        return [
            {
				_border: '', margin: '10px 10px 10px 10px', padding:  '10px 10px 10px 10px', minWidth: '90%', items:[
                    { _text: '预支单号', minWidth: '45%', disabled: true },
                    { _datetime: '申请时间', minWidth: '45%', disabled: true, },
                    { _text: '申请人', minWidth: '45%', disabled: true },
                    { _text: '申请部门', minWidth: '45%', disabled: true },
                    { _select: '预支人', minWidth: '45%', required: true, editable: true, onChange: (v) => this.handleRelatedPersonChange(v), },
                    { _text: '预支部门', minWidth: '45%', disabled: true },
                ]
            },
            {
                _border: '', margin: '10px 10px 10px 10px', padding:  '10px 10px 10px 10px', minWidth: '90%', items:[
                    { _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v), },
                    { _float: '汇率', minWidth: '45%', disabled: true, decimals: 4 },
                    { _float: '预支金额', minWidth: '45%', required: true, textAlign:'left'}, //onChange: (v) => this.handleAdvanceAmountChange(v), },
                    { _text: '用途说明', minWidth: '90%', maxRows: 4, required: false },
                ]
            },
            {
                _border: '', margin: '10px 10px 10px 10px', padding:  '10px 10px 10px 10px', minWidth: '90%', items:[
                    { _radio: '预支名称', minWidth: '90%', },
                    { _select: '委外单位', minWidth: '90%', required: true, cdt: () => 预支名称 == '委外测试费用', editable: true, onChange: (v) => this.handleCustomerNameChange(v, this.props.id), },
                    { _select: '付款方式', minWidth: '45%', required: true,},
                    { _select: '付款条件', name:'付款期限', minWidth: '45%', required: true },
                    { _select: '预支类型', minWidth: '45%', cdt: () => 预支名称 == '其它', onChange: (v) => this.handleAdvanceTypeChange(v, this.props.id), },
                    { _select: `${预支类型 == '客户' ? '客户名称' : '供应商' && 预支类型 == '员工' ? '员工姓名' : '供应商' && 预支类型 == '其他' ? '名称' : '供应商'}`, name: '供应商', minWidth: '45%', editable: true, forceSelection: false, cdt: () => 预支名称 == '其它', onChange: (v) => this.handleCustomerChange(v) },
                    { _text: '开户银行', minWidth: '45%', },
                    { _text: '银行账号', minWidth: '45%', },
                    { _files: '附件', minWidth: '90%', /* required: true */ },
                ]
            },
            // { _select: '所属单位', minWidth: '45%', required: true },
            // { _select: '采购单号', minWidth: '45%', cdt: () => 预支名称 == '其它', editable: true, onChange: (v) => this.handleNumberChange(v), },
            
            
            // { _float: '支付金额', minWidth: '45%', disabled: true },
            // { _select: '税率（%）', name: '税率', minWidth: '45%', onChange: () => this.AutoCalculation() },
            // { _float: '原币金额（未税）', name: '原币金额未税', minWidth: '45%', disabled: true },
            // { _float: '本币金额（未税）', name: '本币金额未税', minWidth: '45%', disabled: true },
            // { _float: '原币金额（含税）', name: '原币金额含税', minWidth: '45%', disabled: true },
            // { _float: '本币金额（含税）', name: '本币金额含税', minWidth: '45%', disabled: true },
            
            // {
            //     _grid: '成本承担部门', name: '成本承担部门', rowNumbers: true, minRows: 1, maxRows: list ? list.length : 1, minWidth: '95%',
            //     columns: [
            //         { _text: '成本承担部门', flex: 5 },
            //         { _text: '部门分摊金额', flex: 2 },
            //         { _text: '部门分摊比例', flex: 1 },
            //     ],
            //     buttons: [
            //         { _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '成本承担部门'), cdt: () => !readOnly && 状态 == '申请中' },
            //     ],
            //     onDoubleTap: data => this.handlerSave(data.id, '成本承担部门')
            // },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this} maxWidth="100%"
            controls={
                readOnly ? [
                    { _button: '打印', icon: 'print', handler: this.handlerAdvanceExport, cdt: () => 状态 == '已完成' || 状态 == '预支打印' || 状态 == '金额支付' || 状态 == '预支确认', disabled: this.bChanged(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ] :
                    [
                        { _flow: 'AdvanceFlow', disabled: this.bChanged() || !this.canSave(), cdt: () => id > 0, },
                        { _button: '打印', icon: 'print', handler: this.handlerAdvanceExport, cdt: () => id > 0 && (状态 == '已完成' || 状态 == '预支打印' || 状态 == '金额支付' || 状态 == '预支确认'), },
                        { _button: '保存', icon: 'save', handler: () => this.handlerSave(0, ''), disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 == '申请中' },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
                        { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },
                    {

                        _fieldsets: [
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                        ], docked: 'right', width: '45%',
                    }
                    // { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), docked: 'bottom', height: '30%', fullblock: true },
                ]
            }
        />
    }
}

export default connect()(AdvanceOrder)